import styled from 'styled-components';

export const SubHeadingWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 0 0 3.5px;
`;
